import React, {CSSProperties} from 'react'
import styled from '@emotion/styled'
import {Carousel} from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import carousel1 from '../../public/img/carousel/carousel_1.png';
import carousel2 from '../../public/img/carousel/carousel_2.png';
import carousel3 from '../../public/img/carousel/carousel_3.png';
import {useTranslation} from "react-i18next";

const Content = styled('div')`    
    li.slide {
        background: #00000000;
    }
`;

const Item = styled('div')`
`;

const ItemImg = styled('img')`
    border-radius: 10px;
`;

const indicatorStyles = {
    background: "#ffffff80",
    width: 8,
    height: 8,
    display: 'inline-block',
    margin: '0 8px',
    borderRadius: '4px'
};

export function FeatureCarousel() {
    const {t} = useTranslation("feature_carousel");

    return <Content>
        <Carousel
            showThumbs={false} showStatus={false} infiniteLoop={true} autoPlay={true} interval={5000}
            showArrows={false} userKeyboardArrows className="presentation-mode"
            renderIndicator={(onClickHandler, isSelected, index, label) => {
                if (isSelected) {
                    return <li style={{...indicatorStyles, background: '#ffffffff'}}
                        aria-label={`${t("Selected")}: ${label} ${index + 1}`}
                        title={`${t("Selected")}: ${label} ${index + 1}`} />;
                } else {
                    return <li style={indicatorStyles}
                        onClick={onClickHandler}
                        onKeyDown={onClickHandler}
                        value={index}
                        role="button"
                        tabIndex={0}
                        aria-label={'${label} ${index + 1}'}
                        title={'${label} ${index + 1}'} />;
                }
            }}
        >
                <Item>
                    <ItemImg src={carousel1} alt={t("Use Gist's rolling abstract to find that moment!")} />
                </Item>
                <Item>
                    <ItemImg src={carousel2} alt={t("Gist hints allow you to easily review related context...")} />
                </Item>
                <Item>
                    <ItemImg src={carousel3} alt={t("Advanced playback saves time and energy!")} />
                </Item>
        </Carousel>
    </Content>;
}
